export class KpiVM {
  public title: KpiTitle;
  public description: string;
  public footer: KpiFooterStats;
  public status: KpiStatus;
  public progress: number;

  constructor(
    title: KpiTitle,
    description: string,
    footer: KpiFooterStats,
    status: KpiStatus,
    progress: number,
  ) {
    this.title = title;
    this.description = description;
    this.footer = footer;
    this.status = status;
    this.progress = progress;
  }
}

export type KpiStatusType = 'ok' | 'warn' | 'danger';

export class KpiStatus {
  static get ok(): KpiStatusType {
    return 'ok';
  }
  static get warn(): KpiStatusType {
    return 'warn';
  }
  static get danger(): KpiStatusType {
    return 'danger';
  }
}

export class KpiTitle {
  public static create(primary: string, secondary: string) {
    return new KpiTitle(primary, secondary);
  }
  constructor(public primary: string, public secondary: string) {}
}

export class KpiFooterStats {
  [key: string]: { value: string; text?: string };
  public static create(value: string, text?: string) {
    return { value, text };
  }
}
